import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export interface ErrorMessageProps {
  message: string;
  variant?: 'inline' | 'block' | 'global';
  dismissible?: boolean;
  onDismiss?: () => void;
  className?: string;
}

const ErrorContainer = styled.div<{ $variant: 'inline' | 'block' | 'global' }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${theme.colors.error};
  font-size: ${props => props.$variant === 'global' ? '0.9rem' : '0.8rem'};
  margin-top: ${props => props.$variant === 'inline' ? '0.25rem' : '0'};
  margin-bottom: ${props => props.$variant === 'global' ? '1.5rem' : '0'};
  
  ${({ $variant }) => {
    switch ($variant) {
      case 'global':
        return `
          background: rgba(220, 53, 69, 0.1);
          padding: 1rem;
          border-radius: ${theme.borderRadius.md};
          text-align: center;
          border: 1px solid ${theme.colors.error};
        `;
      case 'block':
        return `
          padding: 0.75rem;
          background: rgba(220, 53, 69, 0.05);
          border-left: 3px solid ${theme.colors.error};
          border-radius: ${theme.borderRadius.sm};
        `;
      default:
        return '';
    }
  }}
`;

const ErrorText = styled.span`
  flex: 1;
`;

const DismissButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.error};
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
  }
`;

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  variant = 'inline',
  dismissible = false,
  onDismiss,
  className
}) => {
  return (
    <ErrorContainer $variant={variant} className={className}>
      <ErrorText>{message}</ErrorText>
      {dismissible && onDismiss && (
        <DismissButton onClick={onDismiss} aria-label="Dismiss error">
          ✕
        </DismissButton>
      )}
    </ErrorContainer>
  );
};

